import React from 'react'
import { Container } from 'react-bootstrap'
import { IsSpecialEmployer } from 'application/helpers'
import { formatCurrency } from 'application/helpers'

export const TermsAndConditions = ({
  payFrequency,
  showRecommendedRetailPrice,
  nlFeePerAnnumIncGST,
  fbtMethod,
  financierEstablishmentFee,
  spFeePerAnnumIncGST,
  financierFeePerPay
}) => {
  let IsSAGovNSWHealth =
    IsSpecialEmployer('NSWHN', false) || IsSpecialEmployer('SAG', false)
  let isSAGBYO = IsSpecialEmployer('SAGBYO')
  let isACTGO = IsSpecialEmployer('ACTGO')

  return (
    <div className="terms-conditions" id="termsandconditions">
      <Container>
        <div className="font-weight-bold text-brand mb-3">
          Things you should know
        </div>
        <div className="text-smaller">
          <div className="mb-3">
            This general information doesn’t take your personal circumstances
            into account. Please consider whether this information is right for
            you before making a decision and seek professional independent tax
            or financial advice. Conditions and fees apply, along with credit
            assessment criteria for lease and loan products. The availability of
            benefits is subject to your employer’s approval. Maxxia may receive
            commissions in connection with its services.
          </div>
          <div className="font-weight-bold mb-3">
            Novated Lease calculator terms and conditions
          </div>
          <div>
            By using this calculator you agree to our terms and conditions
            below: <br />
            <br />
            <ol>
              <li>
                This calculator provides general information only by using some
                generic taxation scenarios and some publicly available general
                material published on the ATO's website{' '}
                <a
                  href="https://www.ato.gov.au"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                  id="termsandconditions.atolink"
                >
                  www.ato.gov.au
                </a>
                . It does not offer a complete overview of applicable taxation
                methods; This calculator does not use or consider any
                individual’s own financial circumstances at all;{' '}
              </li>
              <li>
                Users must not rely on or consider any results generated by the
                calculator as personal taxation advice.
              </li>
              <li>
                Maxxia is not licensed to provide taxation advice to anyone.
              </li>
              <li>
                Maxxia strongly recommends all users seek their own personal
                taxation advice from a licensed tax adviser before making any
                financial decisions.
              </li>
              <li>
                Maxxia provides no warranties as to the accuracy of the
                estimated results produced by the calculator.
              </li>
            </ol>
          </div>
          <div className="font-weight-bold mb-3">Key considerations</div>

          <ol className="pl-3">
            {fbtMethod && fbtMethod.toLowerCase() === 'ecm' && (
              <div id="termsandconditions.ecmconsideration">
                <li className="mb-3">
                  Novated leasing calculations assume the employee contribution
                  method has been used (pre and post tax funds). The estimated
                  annual operating costs includes estimates of fuel maintenance,
                  tyres, registration, comprehensive insurance.
                </li>
                <li className="mb-3">
                  GST 1/11 is payable on your ECM contributions. Input Tax
                  Credits (i.e. a refund of GST) may be paid to you as salary by
                  your employer. State Stamp Duty rates apply.
                </li>
              </div>
            )}
            <li className="mb-3">
              This proposal does not take into consideration your own personal
              financial situation.
            </li>
            {!isSAGBYO && 
              <li className="mb-3">
                Any optional cover from the Motor Vehicle Lease Options policy
                issued by Pacific Insurance Pty Ltd to be included in the Novated
                Lease will be confirmed separately to the acceptance of this
                Proposal and its terms and conditions.
              </li>
            }
            {IsSAGovNSWHealth && (
              <li id="termsandconditions.loadlimits">
                This vehicle is designed to carry a load of less than one tonne
                and fewer than nine passengers.
              </li>
            )}
          </ol>
          <div className="html2pdf__page-break" />
          <div className="font-weight-bold mb-3">
            How we calculate the price
          </div>
          <div className="mb-3">
            The prices, interest rates, calculations and budgets in this
            estimate are based on information provided and current prices when
            quoted.
          </div>
          <ol>
            <li>
              The prices and interest rates may vary at the time of delivery.
            </li>
            <li>
              Salary Packaging Fees are indicative of packaging a Novated Lease
              only and may vary depending on other items you may be Salary
              Packaging.
            </li>
            <li>
              This Estimate is based on the Annual Salary stated in the Estimate
              and assumes you are claiming the Tax Free Threshold. It may not
              take into account other salary packaging items or deductions.
            </li>
            <li id="termsandconditions.payfrequency">
              The finance has an initial 2 month deferred payment, so first
              payment to the financier starts in month 3 of the lease. However,
              for the purposes of calculating your{' '}
              {payFrequency && (
                <span className="text-brand">{payFrequency.toLowerCase()}</span>
              )}{' '}
              salary packaging deductions, this Estimate depicts your lease
              payments evenly spread across the full lease term.
            </li>
            <li id="termsandconditions.managementfee">
              An indicative annual vehicle management service fee of{' '}
              {formatCurrency(nlFeePerAnnumIncGST)} (incl. GST) has been
              included in your operating expenses. This fee may vary depending
              on your employer.
            </li>
            <li id="termsandconditions.financierestablishmentfee">
              The amount financed includes a Financier Establishment Fee which
              is charged by the financier. This fee may vary depending upon your
              employer and may be up to{' '}
              {formatCurrency(financierEstablishmentFee * 1.1)} (incl GST).
            </li>
            <li>
              The Vehicle Lease Repayments include a {formatCurrency(financierFeePerPay)} {payFrequency.toLowerCase()} account keeping fee which is charged by the financier.
            </li>
            <li id="termsandconditions.adminfee">
              An indicative average administration fee of{' '}
              {formatCurrency(spFeePerAnnumIncGST)} has also been included.
              Please refer to your employer's salary packaging policy for more
              information.
            </li>
            <li>
              A copy of the policy may be obtained from your employer or by
              contacting Maxxia on 1300 123 123.
            </li>
            <li>The calculations used to prepare this quote are based on current income tax rates and threshold.</li>
          </ol>
          <div className="html2pdf__page-break" />
          <div className="font-weight-bold mb-3">Maxxia’s service</div>
          <ol>
            {!isSAGBYO && <>
              <li>
                Maxxia provides administration and referral services on behalf of
                employers.
              </li>
              <li>
                The lease repayments are paid monthly by Maxxia to the financier.
              </li>
            </>
            }
            <li>
              Maxxia does not provide any form of financial, taxation or
              financial product advice to employees on the relative merits of
              package programs or on any other basis.
            </li>
            <li>
              Some information on taxation matters may be provided to illustrate
              possible advantages, but is general information only.
            </li>
            <li>
              Maxxia may pay and/or receive commissions in connection with its services.
            </li>
            <li>The figures presented are for general illustrative purposes only. Maxxia provides no warranties or assurance as to the accuracy of the estimated results produced by the calculator and you should not rely upon them in entering any novated lease or salary packaging arrangements.</li>            
            {isACTGO &&
              <li>All figures (including GST figures) shown are estimates only.  The actual amounts (including GST) payable may vary. Information displayed does not constitute tax, financial or any other form of advice and you should obtain independent legal, taxation and financial advice before proceeding with a novated lease and consider whether it is in your best interests to do so.</li>
            }
            <li>We receive a commission from the financier for introducing you to them.</li>
            <li>
              Tax laws regarding the treatment of salary packaging benefits may
              change, which could adversely impact any financial, taxation or
              welfare benefit decisions.
            </li>
            <li>
              We strongly recommend you seek independent financial advice before
              making any financial decisions regarding a vehicle lease.
            </li>
          </ol>
        </div>
        {showRecommendedRetailPrice && (
          <div id="termsandconitions.recommendedretailpriceinfo">
            <div className="font-weight-bold mb-3">
              Maxxia Novated Leasing Price and Recommended Retail Price
            </div>
            <div className="mb-3">
              † The Maxxia Novated Leasing Price is the amount we pay to acquire
              the vehicle to lease it to you. If you purchase the vehicle on
              termination of the lease, GST is payable on the purchase price you
              pay at that time. Under a novated lease with Maxxia, your lease
              payments will be calculated based on the Maxxia Novated Leasing
              Price which includes 12 months registration, 12 months compulsory
              third party insurance (CTP), dealer delivery charge for
              metropolitan areas, stamp duty, fleet discounts and GST savings.
              Your lease payments will also take into account the finance cost,
              the vehicle running costs based on the lease term, kilometres
              selected and the cost of any additional accessories. <br />
              <br />
              ‡ Recommended Retail Price (RRP) Includes vehicle list price,
              delivery charges, dealer accessory prices, on road costs, Goods &
              Services Tax (GST), GST on fleet discount, aftermarket accessories
              price (inc. GST) and third party option price (inc. GST).
              <br />
            </div>
          </div>
        )}
      </Container>
    </div>
  )
}
